var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.preview
      ? _c(
          "div",
          [
            _c(
              "v-row",
              { staticClass: "text-bold" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "2" } },
                  [
                    _c("v-img", {
                      staticClass: "mt-n2",
                      attrs: {
                        "max-height": "50",
                        "max-width": "50",
                        src: _vm.cardIcon,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-col", { attrs: { cols: "5", align: "start" } }, [
                  _c("span", [
                    _c("strong", [_vm._v("---- ")]),
                    _vm._v(_vm._s(_vm.last4Digits)),
                  ]),
                ]),
                _vm._v(" "),
                _c("v-col", { attrs: { cols: "5" } }, [
                  _vm._v("Expires " + _vm._s(_vm.cardExpires)),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-row",
              { staticClass: "mt-n5" },
              [
                _c("v-col", [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.add = true
                          _vm.preview = false
                        },
                      },
                    },
                    [_c("small", [_vm._v("Add a new card")])]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.add
      ? _c(
          "div",
          [
            _c(
              "v-dialog",
              {
                attrs: { persistent: "", "max-width": "500" },
                model: {
                  value: _vm.add,
                  callback: function ($$v) {
                    _vm.add = $$v
                  },
                  expression: "add",
                },
              },
              [
                _c(
                  "v-card",
                  { staticClass: "mx-auto" },
                  [
                    _c("v-card-title", { staticClass: "text-h5" }, [
                      _vm._v("\n          Add payment method\n        "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml-6 mr-6" },
                      [
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "\n              Card information\n            "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          { staticClass: "mt-n4" },
                          [
                            _c(
                              "v-col",
                              [
                                _c(
                                  "v-card",
                                  { attrs: { outlined: "" } },
                                  [
                                    _c("StripeElements", {
                                      ref: "elms",
                                      staticClass: "pa-2",
                                      attrs: {
                                        "stripe-key": _vm.stripeKey,
                                        "instance-options": _vm.stripeOptions,
                                        "elements-options": _vm.elementsOptions,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ elements }) {
                                              return [
                                                _c("StripeElement", {
                                                  ref: "card",
                                                  attrs: {
                                                    type: "card",
                                                    elements: elements,
                                                    options: _vm.cardOptions,
                                                  },
                                                  on: {
                                                    change: _vm.changeCardInput,
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2541247069
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "error--text mt-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.cardError) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c("span", [
                                _c("small", [
                                  _vm._v(
                                    "Card will be used for all future transactions."
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "entity-button-text",
                            attrs: {
                              outlined: "",
                              color: "secondary",
                              disabled: _vm.pleaseWait,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.add = false
                                _vm.preview = true
                              },
                            },
                          },
                          [_vm._v("\n            Cancel\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "entity-button-text",
                            attrs: {
                              color: "secondary",
                              disabled:
                                _vm.pleaseWait ||
                                !_vm.cardInfoCompleted ||
                                _vm.cardError !== "",
                              loading: _vm.pleaseWait,
                            },
                            on: { click: _vm.addCard },
                          },
                          [_vm._v("\n            Add\n          ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }